/**
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Index file
  Date: April 2020
**/

import React from 'react';
import ReactDOM from 'react-dom';

/** State Management */
import { StoreProvider } from 'easy-peasy';
import store from './state/store';
import App from './App';


// eslint-disable-next-line no-unused-vars
import './assets/scss/styles.scss';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  /**
   * @desc Provides a store for easy peasy state management
   */
  <>
  <StoreProvider store={store}>
    <App />
  </StoreProvider>
  {/* <script src={`//rum-static.pingdom.net/${process.env.REACT_APP_PINGDOM}.js`} async></script> */}
  </>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
